import script from "./StudentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentHeader.vue?vue&type=script&setup=true&lang=js"

import "./StudentHeader.vue?vue&type=style&index=0&id=62331c00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b5029c4e2822f65c6b0ae42e2fbfada5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62331c00"]])

export default __exports__